var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eee;}.cls-2{fill:#00e8e0;}.cls-3{fill:#ef004a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tiktokArtboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.57,13.44v5.93a17.41,17.41,0,0,1-10.73-3.75l0,16.46c0,.28,0,.55,0,.83-.21,1.77-1.17,7.16-6,10.47-5.07,3.47-12.41,3.24-16.69-.83-6.06-5.78-3.6-17,2.55-21.45a13.41,13.41,0,0,1,8-2.33h.25c0,.12,0,.23,0,.35,0,2,.09,4.06.13,6.09-2.93-.41-5.71.5-7.14,2.52a6,6,0,0,0-1,2.92,7.74,7.74,0,0,0,2.46,6,6.87,6.87,0,0,0,5.12,3,6.45,6.45,0,0,0,5.06-2.07,6.08,6.08,0,0,0,1.34-2.75,6.29,6.29,0,0,0,.12-1.3L26,2.17h6.09c0,.12,0,.26.07.42A13.89,13.89,0,0,0,35.22,9h0a1,1,0,0,0,.13.17,13.93,13.93,0,0,0,6.84,4.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.07.27v1.9H26l-.07,31.34a6.29,6.29,0,0,1-.12,1.3,6.08,6.08,0,0,1-1.34,2.75,6.45,6.45,0,0,1-5.06,2.07,6.87,6.87,0,0,1-5.12-3c3.23,1.36,6.6.83,8.4-1.2A5.57,5.57,0,0,0,24,32.64a5.33,5.33,0,0,0,.08-1V.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.92,19.12v8.16a7.1,7.1,0,0,0-7.78,3.52,7,7,0,0,0,.13,5.86,7.74,7.74,0,0,1-2.46-6,6,6,0,0,1,1-2.92c1.43-2,4.21-2.93,7.14-2.52,0-2-.09-4.06-.13-6.09Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.59,16.7v2.07a13.41,13.41,0,0,0-8,2.33C5.48,25.54,3,36.77,9.08,42.55a11.56,11.56,0,0,1-2.82-2.66C2.48,34.82,2.66,25.81,8,20.64,12.41,16.38,18.32,16.62,19.59,16.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.33,13.81v7.43a17.32,17.32,0,0,1-5.28-.72,17,17,0,0,1-5.27-2.67V33.6a14.58,14.58,0,0,1-8.31,13c-.42.19-6.31,2.71-12.09-.37a13.57,13.57,0,0,1-4.3-3.68c4.28,4.07,11.62,4.3,16.69.83,4.82-3.31,5.78-8.7,6-10.47,0-.28,0-.55,0-.83l0-16.46a17.41,17.41,0,0,0,10.73,3.75V13.81Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.2,11.45v1.89a13.93,13.93,0,0,1-6.84-4.19A1,1,0,0,1,35.23,9a12.75,12.75,0,0,0,2.63,1.48A13.26,13.26,0,0,0,42.2,11.45Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.22,9a13.89,13.89,0,0,1-3.08-6.38h1.73A12.75,12.75,0,0,0,34.16,6,13,13,0,0,0,35.22,9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTiktok);
export default __webpack_public_path__ + "static/media/icon_tiktok.2141740aa0b31a518b0a5fd70b428f02.svg";
export { ForwardRef as ReactComponent };